/*
 * Contains some trivial operations which are not worth to be a pipe or directive
 */

import { FormGroup } from '@angular/forms'

export const centToEuro = (cent: number) => {
  return cent / 100
}

export const euroToCent = (euro: number) => {
  return euro * 100
}

/**
 *    Helper to open a contract (image or pdf) in a new browser tab
 */
export const openImageInNewTab = (blob: Blob) => {
  const fileURL = window.URL.createObjectURL(blob)
  window.open(fileURL)
}

/**
 * Returns a typed form control version
 */
export function getTypedFormValue<T>(form: FormGroup, path: string): T | undefined {
  return form.get(path)?.value as T
}
